import { render, staticRenderFns } from "./JKPageEdit.vue?vue&type=template&id=55dc6d64&scoped=true"
import script from "./JKPageEdit.vue?vue&type=script&lang=js"
export * from "./JKPageEdit.vue?vue&type=script&lang=js"
import style0 from "./JKPageEdit.vue?vue&type=style&index=0&id=55dc6d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc6d64",
  null
  
)

export default component.exports